import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import '../../css/transaction.css';

const PaymentCancelled = () => {
  const [searchParams] = useSearchParams();
  const [transactionData, setTransactionData] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // First try to get data from server-injected data
    if (window.BEETZEE_TRANSACTION_DATA) {
      const data = window.BEETZEE_TRANSACTION_DATA;
      setTransactionData({
        transactionId: data.transaction_id,
        merchantRef: data.merchant_ref_code,
        amount: data.amount ? parseFloat(data.amount).toFixed(2) : '0.00'
      });
    } else {
      // Fallback to URL parameters
      const transactionId = searchParams.get('transaction_id');
      const merchantRef = searchParams.get('merchant_ref_code');
      const amount = searchParams.get('amount');
      
      if (merchantRef && amount) {
        setTransactionData({
          transactionId,
          merchantRef,
          amount: parseFloat(amount).toFixed(2)
        });
      }
    }

    // Notify parent window about payment cancellation
    try {
      // Store payment status in localStorage
      localStorage.setItem('paymentStatus', JSON.stringify({
        status: 'cancelled',
        timestamp: Date.now(),
        transactionData: transactionData
      }));

      // Try to communicate with parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'PAYMENT_CANCELLED',
          data: transactionData
        }, '*');
      }
    } catch (error) {
      console.error('Error communicating payment cancellation:', error);
    }
  }, [searchParams, transactionData]);

  // Auto-close countdown effect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Close the window/tab when countdown reaches 0
      window.close();
    }
  }, [countdown]);

  const handleManualClose = () => {
    window.close();
  };

  return (
    <div className="transaction-container">
      <div className="transaction-card cancelled-card">
        <div className="transaction-icon cancelled-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#F59E0B" strokeWidth="2" fill="#FFFBEB"/>
            <path d="M12 8v4" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round"/>
            <path d="m12 16 .01 0" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="transaction-title cancelled-title">Payment Cancelled</h1>
        <p className="transaction-message">
          You have cancelled the payment process. Your booking is still pending and no charges were made.
        </p>

        {transactionData && (
          <div className="transaction-details">
            {transactionData.transactionId && (
              <div className="detail-row">
                <span className="detail-label">Transaction ID:</span>
                <span className="detail-value">{transactionData.transactionId}</span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Reference Number:</span>
              <span className="detail-value">{transactionData.merchantRef}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Amount:</span>
              <span className="detail-value">₱{transactionData.amount}</span>
            </div>
            <div className="detail-row status-detail">
              <span className="detail-label">Status:</span>
              <span className="detail-value cancelled-status">Cancelled - No charge</span>
            </div>
          </div>
        )}

        <div className="countdown-section">
          <div className="countdown-display">
            <p>This window will close automatically in</p>
            <div className="countdown-timer">{countdown}</div>
            <p>seconds</p>
          </div>
          <button onClick={handleManualClose} className="btn btn-secondary close-now-btn">
            Close Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;